import { Injectable } from '@angular/core';

import { Http, Response, RequestOptions, Headers   } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable }     from 'rxjs/Observable';


import { Articulo } from '../model/Articulo';
import { Consorcio } from '../model/Consorcio';
import { Inventario } from '../model/Inventario';

import { UtilitiesService } from '../services/utilities.service'


@Injectable()
export class ArticuloService {

  constructor(
    private _http:Http,
    private _utilities:UtilitiesService

  ) { }

getArticulos(query:any) : Observable<Articulo[]> {
         
    let json = {   "Metodo": "findArticulo",   "Datos":  query};
    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
		return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());       
 
  }

  getArticuloByCodigo(query:any) : Observable<Articulo[]> {
         
    let json = {   "Metodo": "getArticuloByCodigo",   "Datos":  query};
    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
		return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());       
 
  }

  getInventarioByArticulo(query:any) : Observable<Inventario[]> {
         
    let json = {   "Metodo": "getInventarioByArticulo",   "Datos":  query};
    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
		return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());      
 
  }


 public insert(articulo: Articulo){
   
    let json = {   "Metodo": "postArticulo",   "Datos": articulo  };

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());
}


public delete(articulo: Articulo){
  
    let json = {   "Metodo": "deleteArticulo",   "Datos": articulo  };

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());


}

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/articulo.service.ts